/// <reference path="../../../scripts/typings/Nema.Crew.Model.d.ts" />

import service = require("./breeze.entitymanager.service");
import base = require("./base.dataservice");

export function initialize(module: ng.IModule) {
    module.service(AuthorityDataService.Id, AuthorityDataService);

    AuthorityDataService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}

export class AuthorityDataService extends base.BaseDataService<Nema.Crew.Model.Authority> implements IAuthorityDataService {

    constructor(entityManagerService: service.EntityManagerService, breeze, $log, $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }

    public static Id: string = "authorityDataService";

    public get EntityName(): string {
        return "Authority";
    }

    public get EntitiesName(): string {
        return "Authorities";
    }
}

export interface IAuthorityDataService extends base.IDataService<Nema.Crew.Model.Authority> {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/authorities.dataservice.ts